<template>
  <div class="z-border-red pa-2 mb-2" style="position: relative">
    <v-btn
      fab
      depressed
      @click="$emit('onDelete')"
      small
      class="extra-small"
      color="primary"
      style="position: absolute; top: 0; right: 0; margin-top: -15px; margin-right: -15px"
    >
      <em class="fa fa-trash middle" />
    </v-btn>

    <v-layout wrap>
      <v-flex xs12 sm1>
        <move-vertical slot="move" :index="index" :max="max" @onMove="onMove"></move-vertical>
      </v-flex>
      <v-flex xs12 sm1 class="form-control pa-2 text-center">
        <div style="width: 50px" class="ma-auto">
          <uploadfile :height="50" v-model="stock[7]" data-vv-as="Stock Image">
            <v-btn flat fab small><v-icon small>camera_alt</v-icon></v-btn>
          </uploadfile>
        </div>
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'option_' + index"
          :data-vv-name="'option_' + index"
          :data-vv-as="$t('option')"
          v-validate="`required|excluded:${excludestockname}`"
          class="form-control"
          :id="'optionInput' + index"
          :placeholder="$t('option') + ' ' + $t('EX.Size, Color, Weight')"
          v-model="stock[1]"
          @blur="$set(stock, 1, noSpaceAndSpecial($event))"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'sku_' + index"
          :data-vv-name="'sku_' + index"
          :data-vv-as="$t('SKU') + ' (Optional)'"
          class="form-control"
          :id="'skuInput' + index"
          :placeholder="$t('SKU') + ' (Optional)'"
          v-model="stock[5]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'quantity_' + index"
          :data-vv-name="'quantity_' + index"
          :data-vv-as="$t('quantity')"
          v-validate="'required|numeric'"
          maxlength="6"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :id="'quantityInput' + index"
          :placeholder="$t('quantity')"
          v-model="stock[2]"
          @blur="$set(stock, 2, numberOnly($event))"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'price_' + index"
          :data-vv-name="'price_' + index"
          :data-vv-as="$t('Price')"
          v-validate="'decimal:2|min_value:0'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          :id="'priceInput' + index"
          :placeholder="$t('Price') + '(Optional)'"
          v-model="stock[3]"
          @blur="
            $set(stock, 3, decimalOnly($event))
            onBlurPrice($event)
          "
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'saleprice_' + index"
          :data-vv-name="'saleprice_' + index"
          :data-vv-as="$t('Sale price')"
          v-validate="'decimal:2|min_value:0|isLessThanOrEqual:' + stock[3]"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          :id="'salepriceInput' + index"
          :placeholder="$t('Sale price') + '(Optional)'"
          v-model="stock[4]"
          @blur="$set(stock, 4, decimalOnly($event))"
        />
      </v-flex>
      <v-flex xs12>
        <div
          class="form-control"
          :class="{
            'has-error':
              errors.has('option_' + index) ||
              errors.has('quantity_' + index) ||
              errors.has('price_' + index) ||
              errors.has('saleprice_' + index)
          }"
        >
          <span class="text-error" v-show="errors.has('option_' + index)">{{
            errors.first('option_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('quantity_' + index)">{{
            errors.first('quantity_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('price_' + index)">{{
            errors.first('price_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('saleprice_' + index)">{{
            $t('Sale Price cannot be more than Normal Price and less than zero')
          }}</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
import uploadfile from '@/components/elements/uploadfile'
export default {
  inject: ['$validator'],
  props: ['value', 'index', 'max', 'productstock', 'stockkey'],
  data: function () {
    return {
      // stock: this.value
    }
  },
  components: {
    MoveVertical,
    uploadfile
  },
  computed: {
    stock() {
      return this.value
    },
    excludestockname() {
      return this.productstock.filter((el, index) => index != this.stockkey).map((v) => v[1])
    }
  },
  methods: {
    onMove: function (payload) {
      this.$emit('onMove', payload)
    },
    onBlurPrice: function () {
      this.$set(this.stock, 4, this.stock[3])
    }
  },
  watch: {
    // stock: function() {
    //   this.stock = this.value
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStockItem.vue